import React from "react";
import { graphql } from "gatsby";
import Seo from "../components/Seo";
import Layout from "../layouts/sample";

import NewIntro from "../components/front/NewIntro";
import { SubscribeFormNew } from "../components/global/SubscribeFormNew";
import { Clients } from "../components/front/Clients";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { StatsNew } from "../components/front/StatsNew";
import { Value } from "../components/front/Value";
import OpportunitiesSection from "../components/front/Opportunities";
import JoinVideo from "../components/front/JoinVideo";

const IndexPage = (props) => {


  const acf = props.data.page.template?.homePageACF || {};
  const translations = props?.data?.page?.translations || {};
  const stats = props?.data?.page?.template?.statsACF?.numbers || [];

  return (
    <Layout translations={translations}>
      <NewIntro />
      <Value />
      <StatsNew data={acf.intro} stats={stats} numbers={acf.explore} />
      <OpportunitiesSection />
      <Clients />
      <JoinVideo />
    <div className="pt-lg-11 pb-lg-21 pb-16 pt-11" id="subscribe">
      <div className="container">
        <div className="border border-1 rounded-40 subscribe-widget">
          <div className="row align-items-xl-start align-items-md-start">
            <div className="col-12 mb-6 mb-lg-0 col-lg-6">
              <div className="d-flex flex-column gap-4">
                  <div>
                      <span className={`zg-label bg-pink text-black me-2 d-inline-block`}>07</span>
                    <span className={`zg-label bg-pink text-black d-inline-block`}>Subscribe</span>
                  </div>
                  <h2 className="h3 m-0 letter-spacing-4">Newsletter</h2>
                  <p className="fs-7 m-0">Sign up to get monthly updates</p>
              </div>
            </div>
            <div className="col-12 col-lg-6 col-xl-5 offset-xl-1 new-form">
              <SubscribeFormNew/>
            </div>
          </div>
        </div>
      </div>
    </div>
    </Layout>
  );
};

export default IndexPage;

// ✅ Added missing GraphQL query
export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
    page: wpPage(language: { slug: { eq: $language } }, template: { templateName: { eq: "Front Page" } }) {
      title
      seo {
        title
        metaDesc
        opengraphDescription
        opengraphTitle
      }
      translations {
        slug
        isFrontPage
      }
      template {
        ... on WpTemplate_FrontPage {
          statsACF {
            numbers {
              label
              title
              value
              source
              color
            }
          }
          homePageACF {
            intro {
              bottomTitle
              subtext
              subtext1
              link {
                target
                title
                url
              }
              text
              topTitle
              titlePart3
            }
            explore {
              items {
                label
                text
                sufix
              }
              title
            }
          }
        }
      }
    }
  }
`;

export const Head = (props) => {
  const seo = props.data.page?.seo || {};
  return <Seo title={seo?.title} description={seo?.metaDesc} />;
};
